module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "svg",
    style: (_vm.style)
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "width": _vm.length,
      "height": _vm.length
    }
  }, [_c('circle', {
    attrs: {
      "cx": _vm.cy,
      "cy": _vm.cy,
      "r": _vm.r,
      "stroke-width": _vm.width,
      "stroke": _vm.defualtColor,
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": _vm.cy,
      "cy": _vm.cy,
      "r": _vm.r,
      "stroke-width": _vm.width,
      "stroke": _vm.activeColor,
      "fill": "none",
      "transform": _vm.transform,
      "stroke-dasharray": _vm.dasharray
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center"
    },
    style: (_vm.text_box)
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "3",
      "display": "flex",
      "align-items": "center",
      "width": "100%",
      "justify-content": "center",
      "font-weght": "400",
      "font-size": "14px"
    }
  }, [_vm._v("领先")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "4",
      "display": "flex",
      "align-items": "center",
      "width": "100%",
      "justify-content": "center",
      "font-weght": "700",
      "font-size": "18px",
      "color": "#2daa51"
    }
  }, [_vm._v(_vm._s(_vm.rate_text))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "3",
      "display": "flex",
      "align-items": "center",
      "width": "100%",
      "justify-content": "center",
      "font-weght": "400",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.category === 1 ? '用户' : '求职者'))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-640908d0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/svg-circle.vue
// module id = 485
// module chunks = 1